import { render, staticRenderFns } from "./CategoryCustomFieldGroupList.vue?vue&type=template&id=289f8b57&scoped=true"
import script from "./CategoryCustomFieldGroupList.vue?vue&type=script&lang=ts"
export * from "./CategoryCustomFieldGroupList.vue?vue&type=script&lang=ts"
import style0 from "./CategoryCustomFieldGroupList.vue?vue&type=style&index=0&id=289f8b57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289f8b57",
  null
  
)

export default component.exports